import ContractRepayment from './ContractRepayment.vue';

export default ContractRepayment;
